<script>
  import { useUrlParams } from "@stores/urlStore.js";
  import { activitiesStore } from "@stores/activitiesStores.js";
  import { fetchWithSession } from "../util/fetchWithSession";
  import {
    Button,
    TextInput,
    DataTable,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    Pagination,
  } from "carbon-components-svelte";
  import Modal from "lib/components/Modal.svelte";
  import Save16 from "carbon-icons-svelte/lib/Save16";
  import Edit16 from "carbon-icons-svelte/lib/Edit16";
  import Delete16 from "carbon-icons-svelte/lib/Delete16";

  export let selectedNode;
  export let selectedNodes;
  export let triggerUpdate;
  export let subprocessMenuOpen;

  let editActivityName = "";
  let editActivityColor = "#000000";
  let editActivityId = "";
  
  const urlParams = useUrlParams();
  const { deleteActivity, saveActivity } = activitiesStore;

  let allActivities;
  let activityname;
  let filteredRowIds = [];
  let pageSize = 10;
  let page = 1;
  let deleteActivityModalOpen = false;
  let activityid;
  let editids = [];
  let namedict = {};
  let colorDict = {};

  $: ({ analysisid } = $urlParams);
  $: ({ allActivities } = $activitiesStore);
  $: {
    if (selectedNode) {
      fetchWithSession(
        `/api/analysis/getActivityMappingByUnifiedLabel/` +
          analysisid +
          `/` +
          selectedNode,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data) activityid = [data];
          else activityname = "None";
        });
    }
  }

  function updateSubgraph() {
    if (!selectedNodes.includes(selectedNode)) {
      selectedNodes = [...selectedNodes, selectedNode];
    }
    let sendData = selectedNodes;
    fetchWithSession("/api/analysis/addActivityMappingUIElement", {
      method: "POST",
      body: JSON.stringify({
        analysisid: analysisid,
        unifiedlabels: sendData,
        activityid: activityid[0],
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == "success") {
          selectedNodes = [];
          selectedNode = null;
          triggerUpdate = true;
        }
      });
  }
</script>

<Modal
  bind:open={subprocessMenuOpen}
  modalHeading="Add to Activity"
  primaryButtonText="Add to Activity"
  secondaryButtonText="Cancel"
  actions
  autowidth
  on:click:button--secondary={() => (subprocessMenuOpen = false)}
  primaryButtonAction={() => {
    updateSubgraph();
    subprocessMenuOpen = false;
  }}
  size="sm"
  preventCloseOnClickOutside
>
  <DataTable
    size="compact"
    rows={allActivities}
    sortable
    {pageSize}
    {page}
    headers={[
      {
        key: "activity_name",
        value: "Activity",
      },
      {
        key: "color",
        value: "Color",
      },
      {
        key: "menu",
        empty: true,
      },
    ]}
    radio
    bind:selectedRowIds={activityid}
  >
    <Toolbar>
      <ToolbarContent>
        <ToolbarSearch shouldFilterRows bind:filteredRowIds />
      </ToolbarContent>
    </Toolbar>
    <svelte:fragment slot="cell" let:cell let:row>
      {#if !editids.includes(row.id)}
        {#if cell.key == "color"}
          <input
            type="color"
            value={cell.value}
            disabled
            style="border:1px solid #grey; background-color:white;"
          />
        {:else if cell.key == "menu"}
          <Button
            iconDescription="Edit"
            size="small"
            kind="tertiary"
            icon={Edit16}
            on:click={() => {
              editids.push(row.id);
              editids = editids;
              namedict[row.id] = row.activity_name;
              colorDict[row.id] = row.color;
            }}
          />
          <Button
            iconDescription="Delete"
            size="small"
            kind="danger-tertiary"
            icon={Delete16}
            on:click={() => {
              editActivityId = row.id;
              console.log({ editActivityId });
              deleteActivityModalOpen = true;
            }}
          />
        {:else}
          {cell.value}
        {/if}
      {:else if cell.key == "color"}
        <input
          type="color"
          bind:value={colorDict[row.id]}
          style="border:1px solid #ff5f1f; background-color:white;"
        />
      {:else if cell.key == "menu"}
        <Button
          iconDescription="Save"
          size="small"
          kind="tertiary"
          icon={Save16}
          on:click={() => {
            saveActivity(
              namedict[row.id],
              colorDict[row.id],
              row.id,
              analysisid,
            );
            editids = editids.filter((id) => id != row.id);
            editids = editids;
          }}
        />
      {:else}
        <TextInput bind:value={namedict[row.id]} size="sm" />
      {/if}
    </svelte:fragment>
  </DataTable>
  <Pagination
    bind:pageSize
    bind:page
    totalItems={filteredRowIds.length}
    pageSizeInputDisabled
  />
  <div class="inputwrapper">
    <TextInput
      size="sm"
      labelText="Add New Activity"
      placeholder="Define Activity Name"
      bind:value={editActivityName}
    />
    <input
      type="color"
      bind:value={editActivityColor}
      style="margin-top:24px; border:1px solid #ff5f1f; background-color:white; width:80px;"
    />
    <Button
      iconDescription="Add"
      style="margin-top:23px; margin-left:6px;"
      size="small"
      kind="tertiary"
      icon={Save16}
      on:click={() => {
        saveActivity(editActivityName, editActivityColor, null, analysisid);
      }}
    />
  </div>
</Modal>

<Modal
  bind:open={deleteActivityModalOpen}
  kind="danger"
  actions
  autowidth
  modalHeading="Delete Activity?"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  preventCloseOnClickOutside
  on:click:button--secondary={() => (deleteActivityModalOpen = false)}
  primaryButtonAction={() => {
    editActivityId = editActivityId;
    deleteActivity(editActivityId, analysisid);
    deleteActivityModalOpen = false;
  }}
  size="sm"
>
  This will delete the activity. All elements will be reset to no activity.
</Modal>

<style>
  .inputwrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
</style>
